import { render } from "./FrancaisAdvancedMaterials.vue?vue&type=template&id=6d9aa28e"
import script from "./FrancaisAdvancedMaterials.vue?vue&type=script&lang=js"
export * from "./FrancaisAdvancedMaterials.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__